import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const Section = styled('section', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '20px 22px',
    border: '1.5px solid',
    borderColor: 'quickpass.primarySoft',
    boxShadow: '0 12px 32px -22px rgba(128, 84, 255, 0.18)',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const SectionHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '12px',
  },
})

const SectionTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.primary',
    margin: '0',
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
  },
})

const InsightList = styled('ul', {
  base: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const InsightRow = styled('li', {
  base: {
    display: 'grid',
    gridTemplateColumns: '40px 1fr',
    gap: '14px',
    alignItems: 'flex-start',
    paddingY: '10px',
    paddingX: '12px',
    borderRadius: 'md',
    backgroundColor: 'quickpass.surfaceCool',
  },
  variants: {
    severity: {
      info: { backgroundColor: 'quickpass.surfaceCool' },
      nudge: { backgroundColor: 'rgba(255, 203, 107, 0.18)' },
      celebrate: { backgroundColor: 'rgba(127, 216, 181, 0.22)' },
    },
  },
  defaultVariants: {
    severity: 'info',
  },
})

const Glyph = styled('span', {
  base: {
    width: '40px',
    height: '40px',
    borderRadius: 'pill',
    backgroundColor: '#FFFFFF',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    flexShrink: '0',
  },
})

const Body = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: '0',
  },
})

const Title = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
    letterSpacing: '-0.1px',
  },
})

const Text = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.45',
  },
})

const Cta = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
    marginTop: '2px',
    _hover: {
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

export {
  Section,
  SectionHeader,
  SectionTitle,
  InsightList,
  InsightRow,
  Glyph,
  Body,
  Title,
  Text,
  Cta,
}
